import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "LiverType",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "IsNormal",
    isNumber: true,
  },
];

export const CareVillageToHepatitis = {
  label: "照護鄉鎮VS肝炎",
  key: "CareVillageToHepatitis",
  path: "HepatitisTracking/CareVillageToHepatitis",
  api: "TCS_V_LiverS031",
  render: (options) => (
    <Diagram.HepatitisTracking.CareVillageToHepatitis {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
